exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".browse-jobs {\n  margin: 0px 20px;\n  cursor: pointer;\n}\n\n.browse-jobs-list md-divider.day-divider {\n  border: 10px solid #E6E6E7; \n}\n\n.interview-icon {\n  margin: 20px auto;\n  border: 2px solid #E6E6E7;\n  border-radius: 50%;\n  height: 120px;\n  padding: 20px;\n  width: 120px;\n  \n}\n\n.browse-job-schedule {\n  font-size: 13px;\n  line-height: 20px;\n  color: #7A7B81;\n}\n", ""]);

// exports
